export default "__VITE_ASSET__ZnCr4hmM__"